import gql from "graphql-tag";

export const FEATURE_IMG_FRAGMENT = gql`
fragment featureImgFragment on featureImg {
  caption
  img {
    urls
  }
}
`;